// ── BREDA cart sync ───────────────────────────────────────────────────────────
// 1. Ensures cart drawer updates after add-to-cart from product pages.
// 2. Handles upsell add/remove AJAX so the drawer never redirects.

async function bredarRefreshCartDrawer() {
  const cartItems = document.querySelector('cart-items-component[data-drawer]');
  if (!cartItems?.dataset.sectionId) return;

  const sectionId = cartItems.dataset.sectionId.replace(/^shopify-section-/, '');
  const url = new URL(window.location.href);
  url.searchParams.set('section_id', sectionId);
  url.searchParams.sort();

  const response = await fetch(url.toString());
  if (!response.ok) return;

  const html = await response.text();
  const doc = new DOMParser().parseFromString(html, 'text/html');

  // Sync dialog class — removes cart-drawer--empty when cart now has items
  const newDialog = doc.querySelector('.cart-drawer__dialog');
  const oldDialog = document.querySelector('.cart-drawer__dialog');
  if (newDialog && oldDialog) {
    oldDialog.className = newDialog.className;
    const newLabel = newDialog.getAttribute('aria-labelledby');
    if (newLabel) oldDialog.setAttribute('aria-labelledby', newLabel);
  }

  // Replace cart inner content
  const newInner = doc.querySelector('[data-hydration-key="cart-drawer-inner"]');
  const oldInner = document.querySelector('[data-hydration-key="cart-drawer-inner"]');
  if (newInner && oldInner) {
    oldInner.innerHTML = newInner.innerHTML;
  }
}

// ── Upsell add-to-cart (AJAX, no redirect) ───────────────────────────────────
document.addEventListener('submit', async function (event) {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  if (!form.hasAttribute('data-bci-add')) return;

  event.preventDefault();

  const btn = form.querySelector('.bci__btn');
  const variantId = form.querySelector('input[name="id"]')?.value;
  if (!variantId) return;

  if (btn) { btn.disabled = true; }

  try {
    const body = new FormData();
    body.append('id', variantId);
    body.append('quantity', '1');

    const res = await fetch(Theme.routes.cart_add_url, { method: 'POST', body });
    if (res.ok) {
      await bredarRefreshCartDrawer();
    }
  } catch {
    if (btn) { btn.disabled = false; }
  }
});

// ── Upsell remove (AJAX, no redirect) ────────────────────────────────────────
document.addEventListener('submit', async function (event) {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  if (!form.hasAttribute('data-bci-remove')) return;

  event.preventDefault();

  const btn = form.querySelector('.bci__remove-btn');
  const line = form.querySelector('input[name="line"]')?.value;
  if (!line) return;

  if (btn) { btn.disabled = true; }

  try {
    const res = await fetch(Theme.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: 0 }),
    });
    if (res.ok) {
      await bredarRefreshCartDrawer();
    }
  } catch {
    if (btn) { btn.disabled = false; }
  }
});

// ── PDP add-to-cart drawer sync ───────────────────────────────────────────────
// Horizon's morphSection runs synchronously before this listener fires.
// If it handled the update, the dialog's cart-drawer--empty class is already gone.
// We only refresh when it's still present (empty state not cleared by Horizon).
document.addEventListener('cart:update', async function (event) {
  const detail = event.detail;
  if (detail?.data?.source !== 'product-form-component') return;
  if (detail?.data?.didError) return;

  const dialog = document.querySelector('.cart-drawer__dialog');
  if (!dialog?.classList.contains('cart-drawer--empty')) return;

  try {
    await bredarRefreshCartDrawer();
  } catch {
    // Worst case: stale drawer until next page load.
  }
});
